import api from './api';

export interface Lead {
  id: string;
  userId: string;
  companyId?: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  companyName?: string;
  jobTitle?: string;
  status: 'new' | 'contacted' | 'qualified' | 'converted' | 'lost';
  source?: string;
  priority: 'low' | 'medium' | 'high';
  rating: number; // 0-5
  assignedTo?: string;
  estimatedValue?: number;
  currency: string;
  notes?: string;
  nextFollowUp?: string;
  convertedDate?: string;
  convertedToClientId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateLeadData {
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  companyName?: string;
  jobTitle?: string;
  status?: 'new' | 'contacted' | 'qualified' | 'converted' | 'lost';
  source?: string;
  priority?: 'low' | 'medium' | 'high';
  rating?: number;
  assignedTo?: string;
  estimatedValue?: number;
  currency?: string;
  notes?: string;
  nextFollowUp?: string;
  companyId?: string;
}

export interface UpdateLeadData {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  companyName?: string;
  jobTitle?: string;
  status?: 'new' | 'contacted' | 'qualified' | 'converted' | 'lost';
  source?: string;
  priority?: 'low' | 'medium' | 'high';
  rating?: number;
  assignedTo?: string;
  estimatedValue?: number;
  currency?: string;
  notes?: string;
  nextFollowUp?: string;
  convertedDate?: string;
  convertedToClientId?: string;
  companyId?: string;
}

export interface LeadFilters {
  status?: 'new' | 'contacted' | 'qualified' | 'converted' | 'lost';
  priority?: 'low' | 'medium' | 'high';
  source?: string;
  assignedTo?: string;
}

export const leadsApi = {
  getAll: async (filters?: LeadFilters): Promise<Lead[]> => {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.priority) params.append('priority', filters.priority);
    if (filters?.source) params.append('source', filters.source);
    if (filters?.assignedTo) params.append('assignedTo', filters.assignedTo);

    const queryString = params.toString();
    const url = `/leads${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data.data;
  },

  getById: async (id: string): Promise<Lead> => {
    const response = await api.get(`/leads/${id}`);
    return response.data.data;
  },

  create: async (data: CreateLeadData): Promise<Lead> => {
    const response = await api.post('/leads', data);
    return response.data.data;
  },

  update: async (id: string, data: UpdateLeadData): Promise<Lead> => {
    const response = await api.put(`/leads/${id}`, data);
    return response.data.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/leads/${id}`);
  },
};
